import { DialogComponent } from "@theme/dialog";
import { CartAddEvent } from "@theme/events";

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.#setupCheckoutAnimation();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener("click", this.#handleCheckoutClick);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute("auto-open")) {
      this.showDialog();
    }
  };

  #handleCheckoutClick = (e) => {
    if (!e.target.closest("#checkout")) return;
    this.querySelector(".checkout-animation")?.classList.remove("opacity-0");
  };

  #setupCheckoutAnimation() {
    if (!this.querySelector(".checkout-animation")) return;
    this.addEventListener("click", this.#handleCheckoutClick);
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined("shopify-payment-terms").then(() => {
      const installmentsContent = document.querySelector(
        "shopify-payment-terms",
      )?.shadowRoot;
      const cta = installmentsContent?.querySelector(
        "#shopify-installments-cta",
      );
      cta?.addEventListener("click", this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get("cart-drawer-component")) {
  customElements.define("cart-drawer-component", CartDrawerComponent);
}
